export class ResponseError extends Error {
	constructor(
		message: string,
		readonly status: number,
		readonly body: object,
	) {
		super(message);
	}
}
